import React from 'react';
import { render } from 'react-dom'
import "./assets/animated.css";
import '../node_modules/font-awesome/css/font-awesome.min.css'; 
import '../node_modules/elegant-icons/style.css';
import '../node_modules/et-line/style.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.js';
import './assets/style.scss';
import App from './components/app';
import * as serviceWorker from './serviceWorker';
// import { Provider as AlertProvider } from 'react-alert'
// import AlertTemplate from 'react-alert-template-basic'


// // optional cofiguration
// const options = {
// 	position: 'top right',
// 	timeout: 10000,
// 	offset: '30px',
// 	transition: 'scale'
//   }

// const Root = () => {
// 	return(
// 	<AlertProvider template={AlertTemplate} {...options}>
// 	  <App />
// 	</AlertProvider>
// 	)
//   }
  

render(
<App />
, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();